import type {
  ProductsCollectionResponse,
  ProductsAllRequest,
  ProductsAllResponse,
  ProductsCollectionRequest,
  ProductsByIdsRequest,
  ProductsByIdsResponse,
  TopRankedProductsRequest,
  TopRankedProductsResponse,
  ProductTaxonomy,
} from '@/infrastructure/product/utils/types';
import { client } from '../common/client';

class ProductAPIClient {
  public async getProductsAll(params?: ProductsAllRequest): Promise<ProductsAllResponse> {
    return await client.get(`/products/all`, { params }).then((res) => res.json());
  }

  public async getProductsCollections(params?: ProductsCollectionRequest): Promise<ProductsCollectionResponse> {
    const res = await client.get(`/products/collection`, { params });
    return await res.json();
  }

  public async getProductsByIds(params: ProductsByIdsRequest): Promise<ProductsByIdsResponse> {
    const res = await client.get(`/products/byIds`, { params });
    return await res.json();
  }

  public async getTopRankedProducts(params?: TopRankedProductsRequest): Promise<TopRankedProductsResponse> {
    // In a real implementation, we'd call a specific API endpoint for top ranked products
    // For now, we'll reuse the collections endpoint and filter by category on the client side
    const response = await this.getProductsCollections({
      collectionName: 'Rankings by Product Category',
      limit: 100,
      page: 1,
      ...params,
    });

    return response;
  }

  public async getProductTaxonomy(): Promise<ProductTaxonomy> {
    return await client.get('/product/taxonomy').then((res) => res.json());
  }
}

export const productAPIClient = new ProductAPIClient();
